export default __webpack_public_path__ + "static/media/errorPage.f1c84e8d.png";